(function () {
  'use strict';

  function prepareVideo(video) {
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
  }

  function removeOverlay(deferredMedia) {
    const poster = deferredMedia.querySelector('.deferred-media__poster');
    if (poster) poster.style.display = 'none';
  }

  function loadAndPlayDeferredMedia(deferredMedia) {
    // Trigger the deferred-media load if not already loaded
    if (!deferredMedia.hasAttribute('loaded')) {
      const playBtn = deferredMedia.querySelector('.deferred-media__poster');
      if (playBtn) playBtn.dispatchEvent(new Event('click', { bubbles: true }));
    }

    // Wait for the video element to appear after load
    const tryPlay = setInterval(() => {
      const video = deferredMedia.querySelector('video');
      if (video) {
        clearInterval(tryPlay);
        prepareVideo(video);
        removeOverlay(deferredMedia);
        video.play().catch(() => {});

        // Tap to toggle pause
        video.addEventListener('click', () => {
          video.paused ? video.play() : video.pause();
        });
      }
    }, 100);

    // Give up after 5 seconds
    setTimeout(() => clearInterval(tryPlay), 5000);
  }

  function pauseAllVideosInGallery(gallery) {
    gallery.querySelectorAll('video').forEach((v) => {
      if (!v.paused) v.pause();
    });
  }

  function getActiveSlide(gallery) {
    return (
      gallery.querySelector('.slider__slide.is-active') ||
      gallery.querySelector('.slider__slide[aria-hidden="false"]') ||
      gallery.querySelector('.slider__slide:first-child')
    );
  }

  function handleSlideChange(gallery) {
    pauseAllVideosInGallery(gallery);

    const activeSlide = getActiveSlide(gallery);
    if (!activeSlide) return;

    const deferredMedia = activeSlide.querySelector('deferred-media');
    if (deferredMedia) {
      loadAndPlayDeferredMedia(deferredMedia);
      return;
    }

    // Fallback: plain video element (no deferred wrapper)
    const video = activeSlide.querySelector('video');
    if (video) {
      prepareVideo(video);
      video.play().catch(() => {});
    }
  }

  function initGallery(gallery) {
    const slider = gallery.querySelector('[id^="Slider-Gallery"]');
    if (!slider) return;

    // Observe slide class/aria changes for carousel navigation
    const observer = new MutationObserver(() => handleSlideChange(gallery));
    slider.querySelectorAll('.slider__slide').forEach((slide) => {
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden'],
      });
    });

    // Trigger on initial load
    handleSlideChange(gallery);
  }

  function init() {
    document.querySelectorAll('[id^="MediaGallery-"]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
